// eslint-disable-next-line import/prefer-default-export
export class ValueTransformer {
  /**
   * Removes whitespaces from comma separated values
   * @param value
   */
  static cleanUpCommaSeparatedValues(value: string) {
    if (value) {
      return value
        .split(',')
        .map((val) => val.trim())
        .filter((val) => val)
        .join(',');
    }
    return '';
  }

  /**
   * Removes whitespaces from comma separated values and return array of strings
   * @param value
   * @param splitter
   */
  static splitUpCommaSeparatedValues(value: string, splitter = ','): string[] {
    if (value) {
      return value
        .split(splitter)
        .map((val) => val.trim())
        .filter((val) => val);
    }
    return [];
  }

  /**
   * Removes whitespaces from comma separated values and returns as string[]
   * @param value
   */
  static cleanUpCommaSeparatedValuesToArray(value: string): string[] {
    if (value) {
      return value
        .split(',')
        .map((val) => val.trim())
        .filter((val) => val);
    }
    return [];
  }

  /**
   * Returns whether the given value is null or undefined
   * @param value
   */
  static isNullOrUndefined(value: unknown) {
    return value === null || value === undefined;
  }

  /**
   * Determines whether given value is an empty string
   * @param value
   */
  static isNonEmpty(value: string) {
    if (ValueTransformer.isNullOrUndefined(value)) {
      return false;
    }
    return !!value.trim();
  }

  /**
   * Searches for white spaces in a string and replaces it with given value
   * @param searchString - String to search in
   * @param replaceValue - Value to replace white-spaces with
   */
  static replaceSpaces(searchString: string, replaceValue: string) {
    return searchString.trim().replace(/ /g, replaceValue);
  }

  static equalsIgnoreCase(value1 = '', value2 = '') {
    return value1.toLowerCase() === value2.toLowerCase();
  }
}
